import { DEFAULT_LAYOUT, leafLabel, groupLabel } from "./navLayout";

export const moduleOf = (v) => {
  if (v === "car-maintenance" || v === "moto-maintenance" || v === "spareparts") return "maintenance";
  if (typeof v === "string" && v.startsWith("insurance")) return "insurance";
  if (typeof v === "string" && v.startsWith("riders")) return "riders";
  if (v === "meetings" || v === "biz-calendar" || v === "workspace") return "business";
  if (v === "live-roster") return "rider-map";
  return v;
};

export const PERM_ACTIONS = [
  { id: "view", label: "عرض" },
  { id: "add", label: "إضافة" },
  { id: "edit", label: "تعديل" },
  { id: "delete", label: "حذف" },
  { id: "approve", label: "اعتماد" },
  { id: "export", label: "تصدير" },
];

const EXTRA_LABELS = { business: "إدارة الأعمال", reports: "التقارير" };
export const moduleLabel = (m, t) => EXTRA_LABELS[m] || leafLabel(m, null, t);

export const buildPermGroups = (modules, t) => {
  const avail = new Set(modules);
  const used = new Set();
  const take = (keys) => [...new Set(keys.map(moduleOf))].filter((k) => avail.has(k) && !used.has(k) && used.add(k));
  const groups = [];
  const loose = [];
  DEFAULT_LAYOUT.forEach((n) => {
    if (n.t === "group") {
      const keys = take(n.children);
      if (keys.length) groups.push({ id: n.id, label: groupLabel(n, t), keys });
    } else loose.push(...take([n.v]));
  });
  loose.push(...take(modules));
  if (loose.length) groups.push({ id: "other", label: "أقسام عامة", keys: loose });
  return groups;
};

export const countGranted = (matrix) => Object.values(matrix || {}).filter((r) => r?.view).length;
